import React, { useEffect, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import AskValue from "../global/BidAsk/AskValue";
import BidValue from "../global/BidAsk/BidValue";
import i18n from "i18next";
import GroupProfitLoss from "../tab/tabview/netTrade/GroupProfitLoss";
import GroupInterest from "../tab/tabview/netTrade/GroupIntrest";
import GroupCommission from "../tab/tabview/netTrade/GroupCommission";
import GroupNetValue from "../tab/tabview/netTrade/GroupNetValue";
import GroupNetOpenValue from "../tab/tabview/netTrade/GroupNetOpenValue";

const defaultRender = (value) => (value ? value : "--");
const formatPrice = (value, decimalPlaces) => {
    if (value === null || value === undefined) return "";
    return Number(value)?.toFixed(decimalPlaces);
};

const useNetTradeCell = () => {
    const { t } = useTranslation();
    const decimalPlaces = useSelector((state) => state.user.decimalPlacesForAmountFormatting);
    const { symbols } = useSelector(state => state.watchlist)

    const getDigitsBySymbolId = (symbolId) => {
        return symbols?.[symbolId]?.digits;
    }
    const columns = useMemo(() => ([
        { title: t("symbol"), width: 130, dataIndex: "symbolName", render: defaultRender },
        { title: t("amount"), width: 100, dataIndex: "amount", render: (value) => formatPrice(value, decimalPlaces) },
        {
            title: t("NH"), width: 100, dataIndex: "nh", render: (value) => formatPrice(value, decimalPlaces)

        },
        { title: t("B/S"), width: 70, dataIndex: "side", render: (value) => value === 1 ? t("buy") : t("sell") },
        {
            title: t("avgOpenPrice"), width: 120, dataIndex: "openPrice", render: (value, row) => {
                const digits = getDigitsBySymbolId(row.symbolId);
                return value?.toFixed?.(digits);
            }
        },
        {
            title: t("currentPrice"), width: 140, dataIndex: "currentPrice",
            render: (value, row) =>
                row?.side === -1 ? <AskValue symbolId={row.symbolId} digits={row.digits} /> : <BidValue symbolId={row.symbolId} digits={row.digits} />
        },

        { title: t("commission"), width: 100, dataIndex: "commission", render: (value, row) => <GroupCommission positionList={row.positionList} symbolId={row.symbolId} side={row.side} /> },
        { title: t("swap"), width: 90, dataIndex: "interest", render: (value, row) => <GroupInterest positionList={row.positionList} /> },
        { title: t("P/L"), width: 100, dataIndex: "profit", render: (value, row) => <GroupProfitLoss positionList={row.positionList} symbolId={row.symbolId} side={row.side} /> },
        { title: t("netValue"), width: 100, dataIndex: "netValue", render: (value, row) => <GroupNetValue positionList={row.positionList} symbolId={row.symbolId} side={row.side} /> },
        { title: t("netOpenValue"), width: 100, dataIndex: "netOpenValue", render: (value, row) => <GroupNetOpenValue positionList={row.positionList} symbolId={row.symbolId} /> },

    ]), [decimalPlaces, t]);
    useEffect(() => {
        console.log("NetTrade Columns recomputed");
    }, [columns]);

    return columns;

};


export default useNetTradeCell;
